var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.76,
    height: 33.76,
    viewBox: "0 0 33.76 33.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "log-out",
    d: "M11.815,0a1.688,1.688,0,0,1,.2,3.364l-.2.012H5.064a1.688,1.688,0,0,0-1.676,1.49l-.012.2V28.7a1.688,1.688,0,0,0,1.49,1.676l.2.012h6.752a1.688,1.688,0,0,1,.2,3.364l-.2.012H5.064A5.064,5.064,0,0,1,.008,28.993L0,28.7V5.064A5.064,5.064,0,0,1,4.767.008L5.064,0Zm12.85,7.106.159.14,8.44,8.44a1.688,1.688,0,0,1,.135.152l-.135-.152a1.706,1.706,0,0,1,.169.189,1.374,1.374,0,0,1,.084.127l.035.062c.019.034.035.068.052.1s.027.057.039.088.025.068.037.1.015.051.024.078.019.073.027.11a.741.741,0,0,1,.015.088c0,.029.008.069.012.1a.85.85,0,0,1,0,.093v.052a1.715,1.715,0,0,1-.019.251.566.566,0,0,1-.015.088c-.005.03-.017.074-.025.11a.739.739,0,0,1-.024.078c-.008.025-.024.066-.035.1a.854.854,0,0,1-.039.088c-.014.029-.034.069-.052.1l-.035.061q-.041.064-.084.125l-.022.03-.017.02-.123.138-8.44,8.44A1.688,1.688,0,0,1,22.3,24.284l.14-.159,5.558-5.557H11.815a1.688,1.688,0,0,1-.2-3.364l.2-.012H27.994L22.438,9.633a1.688,1.688,0,0,1-.14-2.228l.14-.159A1.688,1.688,0,0,1,24.666,7.106Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.dd4b09dce2dea8a725abba3a23b9fe81.svg";
export { ForwardRef as ReactComponent };